@charset "UTF-8";

/* src/app/acs-chat/components/chat-widget/chat-widget.scss */
:host {
  position: fixed;
  z-index: 99999;
  font-family:
    "Segoe UI",
    Roboto,
    "Helvetica Neue",
    Arial,
    sans-serif;
}
.chat-panel {
  position: fixed;
  bottom: 24px;
  right: 24px;
  width: 400px;
  height: 620px;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
}
.drag-handle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 12px;
  background: #f5f5f5;
  border-bottom: 1px solid #e0e0e0;
  cursor: move;
  -webkit-user-select: none;
  user-select: none;
  flex-shrink: 0;
}
.drag-handle-label {
  color: #555;
  font-weight: 500;
  font-size: 12px;
}
.minimize-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s;
}
.minimize-btn:hover {
  background: rgba(0, 0, 0, 0.08);
}
.minimize-btn svg {
  fill: #666;
}
.user-picker {
  padding: 16px;
  overflow-y: auto;
  flex: 1;
}
.user-picker h3 {
  margin: 0 0 12px;
  font-size: 18px;
  font-weight: 700;
}
.user-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 10px;
  border: none;
  background: transparent;
  border-radius: 10px;
  cursor: pointer;
  font-size: 15px;
  font-family: inherit;
  text-align: left;
  transition: background 0.15s;
}
.user-row:hover {
  background: #f2f2f7;
}
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}
/*# sourceMappingURL=chat-widget.css.map */
